import { useTranslate } from '@refinedev/core';
import { Space, Typography, theme } from 'antd';
import { isLossy } from './creative';
import type { CropInfo } from './creative';

const { Text } = Typography;

interface CreativeDimensionsProps {
  width: number;
  height: number;
  /**
   * Crop the container will apply. Null when it cannot be computed —
   * or when the creative never reaches a container to be cropped by.
   */
  crop: CropInfo | null;
}

/** Stored size of a creative, and the bad news underneath it. */
export const CreativeDimensions = ({
  width,
  height,
  crop,
}: CreativeDimensionsProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();

  return (
    <Space direction="vertical" size={0}>
      <Text code>{`${width} × ${height}`}</Text>
      {isLossy(crop) && crop && (
        <Text style={{ fontSize: token.fontSizeSM, color: token.colorWarning }}>
          {t('base.creative.crop_lossy', {
            percent: Math.round(crop.loss * 100),
          })}
        </Text>
      )}
    </Space>
  );
};
